export const REFRESH_URL = 'v1/refresh';
export const AUTH_REFRESH_TIME_WINDOW_MILLISECONDS = 20 * 60 * 1000;
export const TestingFrameworkConfiguration = { runs: 10 };

export const HTTP_CODES = {
  Success: 200,
  SuccessCreate: 201,
  Accepted: 202,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  UnprocessableEntity: 422,
  RateLimit: 429,
  CognitoError: 423,
  InternalServerError: 500,
};

export enum FetchLoadingStateEnum {
  loading = 'loading',
  fulfilled = 'fulfilled',
  error = 'error',
  reload = 'reload',
  canceled = 'canceled'
}

export const wordDocBinayType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const staticChannelName = 'exact-report-add-in/document';
